import React, { useState, useEffect, useContext } from "react";
import DataTableComponent from "react-data-table-component";

import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/User/AuthService";
import RechargeService from "../../../../services/User/RechargeService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const RechargeReport = () => {
  const loadingCtx = useContext(LoadingContext);

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [status, setStatus] = useState();
  const [productId, setProductId] = useState();

  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState();
  const [count, setCount] = useState();
  const [data, setData] = useState();

  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();

  const fetch = async () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const _status = params.get("status");

    if (_status) {
      setStatus(_status);
      await fetchData(_status);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // page, size, searchText, fromDate, toDate, status, productId

  const fetchData = async (_status) => {
    const token = AuthService.getAccessToken();

    setLoading(true);

    RechargeService.report(
      token,
      fromDate,
      toDate,
      _status ? _status : status,
      productId,
      searchText,
      page,
      size
    )
      .then((responseData) => {
        if (responseData.status !== "SUCCESS") {
          throw new Error(responseData.message);
        }

        const dataResult = responseData.data.result;
        setCount(responseData.data.count);
        setData(dataResult);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleDispute = async (order_id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.dispute(token, order_id);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);

      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const columns = [
    {
      name: "Date Time",
      cell: (row) => (
        <div>
          <span>{row.created_on}</span>
        </div>
      ),
    },
    {
      name: "Order ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.order_id}</span>
          <br />
          <small>{row.partner_order_id}</small>
        </div>
      ),
    },
    {
      name: "Operator",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <img src={getLogo(row)} alt="logo" height={40} />
        </div>
      ),
    },
    {
      name: "Number",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            {row.optional1}
          </span>
        </div>
      ),
    },
    {
      name: "Amount",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            ₹{row.order_amount}
          </span>
        </div>
      ),
    },
    {
      name: "Commission",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span
            style={{ fontSize: "16px", fontWeight: "bold", color: "green" }}
          >
            ₹{row.commercial_amount}
          </span>
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <h5>
                  <span class="badge badge-success">SUCCESS</span>
                </h5>
              );
            } else if (row.status === "FAILED") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            } else if (row.status === "PENDING") {
              return (
                <h5>
                  <span class="badge badge-warning">PENDING</span>
                </h5>
              );
            } else if (row.status === "REVERSAL") {
              return (
                <h5>
                  <span class="badge badge-danger">REVERSAL</span>
                </h5>
              );
            } else if (row.status === "REFUND") {
              return (
                <h5>
                  <span class="badge badge-danger">FAILED</span>
                </h5>
              );
            }
          })()}
        </div>
      ),
    },
    {
      name: "Response",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          {(() => {
            if (row.status === "SUCCESS") {
              return (
                <span>
                  {row.secret_optional2 ? row.secret_optional2 : "NULL"}
                </span>
              );
            } else {
              return <span>N/A</span>;
            }
          })()}
        </div>
      ),
    },
    {
      name: "Operator Ref",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span> {row.operator_id ? row.operator_id : "NULL"}</span>
        </div>
      ),
    },
    {
      name: "Dispute",
      cell: (row) => (
        <div
          onClick={() => {
            handleDispute(row.order_id);
          }}
        >
          {(() => {
            if (row.secret_optional5 == null) {
              return (
                <div>
                  <button className="badge bg-secondary btn-sm">RAISE</button>
                </div>
              );
            } else if (row.secret_optional5 === "ACCEPTED") {
              return (
                <div>
                  <a className="badge bg-info">REFUNDED</a>
                </div>
              );
            } else if (row.secret_optional5 === "REJECTED") {
              return (
                <div>
                  <a className="badge bg-danger">REJECTED</a>
                </div>
              );
            } else if (row.secret_optional5 === "PENDING") {
              return (
                <div>
                  <a className="badge bg-warning">PENDING</a>
                </div>
              );
            }
          })()}
        </div>
      ),
    },
  ];

  const operators = [
    { value: 1, label: "Airtel", image: "/images/airtel_logo.png" },
    { value: 2, label: "BSNL Topup", image: "/images/bsnl_logo.png" },
    { value: 3, label: "BSNL Special", image: "/images/bsnl_logo.png" },
    { value: 4, label: "JIO", image: "/images/jio_logo.png" },
    { value: 5, label: "Vi", image: "/images/vi_logo.png" },
    {
      value: 6,
      label: "Airtel Digital TV",
      image: "/images/airtel_digital_tv_logo.png",
    },
    { value: 7, label: "Dish TV", image: "/images/dish_tv_logo.png" },
    { value: 8, label: "Sun Direct", image: "/images/sun_direct_logo.png" },
    { value: 9, label: "Tata Sky", image: "/images/tata_sky_logo.png" },
    {
      value: 10,
      label: "Videocon D2H",
      image: "/images/videocon_d2h_logo.png",
    },
    {
      value: 47,
      label: "Google Play",
      image: "/images/google-play-icon-2.png",
    },
  ];

  const getLogo = (row) => {
    let obj = operators.find((o) => o.label === row.product.name);
    if (obj) {
      return obj.image;
    }
    return "";
  };

  const [isLoading, setIsloading] = useState(false);

  const [summaryData, setSummaryData] = useState();

  const getSummary = async () => {
    setIsloading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await RechargeService.summary(
        token,
        fromDate,
        toDate,
        productId
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        setSummaryData(responseData.data);
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    setIsloading(false);
  };

  return (
    <React.Fragment>
      <Templete t1="Home" t2="Recharge Report">
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-default">
                  <div class="card-header">
                    <h3 class="card-title">Recharge Report</h3>
                  </div>

                  <div class="card-body">
                    <div class="row mt-2">
                      <div class="col-md-12 mx-auto">
                        <form autoComplete="off">
                          <div class="row">
                            <div class="col-sm-3">
                              <div class="form-group">
                                <input
                                  type="date"
                                  class="form-control"
                                  placeholder="From Date"
                                  onChange={(e) => {
                                    setFromDate(e.target.value);
                                  }}
                                  defaultValue={fromDate}
                                />
                              </div>
                            </div>

                            <div class="col-sm-3">
                              <div class="form-group">
                                <input
                                  type="date"
                                  class="form-control"
                                  placeholder="To Date"
                                  onChange={(e) => {
                                    setToDate(e.target.value);
                                  }}
                                  defaultValue={toDate}
                                />
                              </div>
                            </div>

                            <div class="col-sm-3">
                              <div class="form-group">
                                <select
                                  className="form-control"
                                  onChange={(e) => {
                                    setStatus(e.target.value);
                                  }}
                                >
                                  <option value={status ? status : ""}>
                                    {status ? status : "Select Status"}{" "}
                                  </option>
                                  <option value="SUCCESS">SUCCESS</option>
                                  <option value="PENDING">PENDING</option>
                                  <option value="REFUND">FAILED</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-sm-3">
                              <div class="form-group">
                                <select
                                  className="form-control"
                                  onChange={(e) => {
                                    setProductId(e.target.value);
                                  }}
                                >
                                  <option value="">Select Operator</option>
                                  <option value="1">Airtel</option>
                                  <option value="2">BSNL Topup</option>
                                  <option value="3">BSNL Special</option>
                                  <option value="4">JIO</option>
                                  <option value="5">Vi</option>
                                  <option value="6">Airtel Digital TV</option>
                                  <option value="7">Dish TV</option>
                                  <option value="8">Sun Direct</option>
                                  <option value="9">Tata Sky</option>
                                  <option value="10">Videocon D2H</option>
                                  <option value="47">Google Play</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-sm-3">
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Search Text"
                                  onChange={(e) => {
                                    setSearchText(e.target.value);
                                  }}
                                />
                              </div>
                            </div>

                            <div
                              class="col-sm-6"
                              style={{ textAlign: "center" }}
                            >
                              <div class="d-grid gap-2 d-md-flex">
                                <button
                                  type="button"
                                  class="btn btn-primary mr-4"
                                  onClick={() => {
                                    fetchData();
                                  }}
                                >
                                  <i class="fa fa-search"></i> Search
                                </button>

                                <button
                                  type="button"
                                  class="btn btn-secondary mr-4"
                                  onClick={() => {
                                    getSummary();
                                  }}
                                >
                                  <i class="fa fa-search"></i> Fetch Summary
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-12 col-sm-6 col-md-4">
                        <div class="info-box">
                          <span class="info-box-icon bg-success elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">TOTAL SUCCESS</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && summaryData
                                ? summaryData.success.rows.length > 0
                                  ? "₹" +
                                    summaryData.success.rows[0].total_amount +
                                    " [" +
                                    summaryData.success.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    summaryData.success.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-4">
                        <div class="info-box mb-4">
                          <span class="info-box-icon bg-warning elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">TOTAL PENDING</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && summaryData
                                ? summaryData.pending.rows.length > 0
                                  ? "₹" +
                                    summaryData.pending.rows[0].total_amount +
                                    " [" +
                                    summaryData.pending.count +
                                    "]"
                                  : "₹0" +
                                    " [" +
                                    summaryData.pending.count +
                                    "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-sm-6 col-md-4">
                        <div class="info-box mb-4">
                          <span class="info-box-icon bg-danger elevation-1">
                            <i class="fas fa-arrow-right"></i>
                          </span>
                          <div class="info-box-content">
                            <span class="info-box-text">TOTAL FAILED</span>
                            <span class="info-box-number">
                              {isLoading && (
                                <div class="spinner-border spinner-border-sm"></div>
                              )}
                              {!isLoading && summaryData
                                ? summaryData.failed.rows.length > 0
                                  ? "₹" +
                                    summaryData.failed.rows[0].total_amount +
                                    " [" +
                                    summaryData.failed.count +
                                    "]"
                                  : "₹0" + " [" + summaryData.failed.count + "]"
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <DataTableComponent
                      noHeader={true}
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationTotalRows={count}
                      paginationPerPage={size}
                      onChangePage={(page) => {
                        setPage(page);
                        fetchData();
                      }}
                      paginationRowsPerPageOptions={[
                        10, 20, 50, 100, 200, 500, 1000,
                      ]}
                      onChangeRowsPerPage={(size) => {
                        setSize(size);
                        fetchData();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Templete>
    </React.Fragment>
  );
};

export default RechargeReport;
